import { render, staticRenderFns } from "./finantial-settings-account-card.vue?vue&type=template&id=6f05be98&scoped=true&"
import script from "./finantial-settings-account-card.vue?vue&type=script&lang=js&"
export * from "./finantial-settings-account-card.vue?vue&type=script&lang=js&"
import style0 from "./finantial-settings-account-card.vue?vue&type=style&index=0&id=6f05be98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f05be98",
  null
  
)

export default component.exports